import { z } from 'zod';
import { createInquiryInput } from './api.js';
/**
 * Anfrageformular für Besucher einer Kundenwebseite, das direkt aus dem Browser an Wirkia sendet (KON-260, siehe docs/webseite.md, Abschnitt
 * „Anfrageformular aus dem Browser“). Bisher ging das nur über den Server der Webseite, weil `/inquiries` keine fremde Herkunft zulässt und keinen Spam-Schutz hat.
 * Die Aufrufe unter `/forms/visitor/…` nehmen den Webseiten-Schlüssel (Bereich `inquiries:create`) an, prüfen die Herkunft wie beim Chat und schützen sich mit
 * Rechenaufgabe, verstecktem Feld und Obergrenzen. Zum Hochladen von Fotos bekommt der Browser mit der Antwort eine kurzlebige Berechtigung für genau diese Anfrage.
 */
export const VISITOR_FORM_LIMITS = {
    /** So lange gilt die Berechtigung zum Hochladen nach dem Absenden */
    uploadMinutes: 30,
    /** Links in der Nachricht: Mehr sind fast immer Spam */
    maxLinks: 3,
};
export const visitorInquiryInput = createInquiryInput
    .omit({ source: true, consentAt: true })
    .extend({
    /** Der Besucher hat das Häkchen zur Datenverarbeitung gesetzt. Den Zeitpunkt setzt der Server. */
    consent: z.literal(true, 'Bitte stimmen Sie der Verarbeitung Ihrer Angaben zu.'),
    /** Die abgeholte und gelöste Rechenaufgabe (GET /forms/visitor/challenge) */
    challenge: z.string().max(400).optional(),
    solution: z.string().max(40).optional(),
    /** Verstecktes Feld, das nur Programme ausfüllen */
    website: z.string().max(200).optional(),
});
//# sourceMappingURL=webforms.js.map